import { throwErrorMsg } from "../../utils/throwErrorMsg"

export const pay = {
  /**
   * 唤起商米收银台扫码支付
   */
  qrCodePay<T = any>(
    amount: number,
    success: (result: T) => void,
    fail: (result: T) => void
  ): void {
    throwErrorMsg("pay.qrCodePay")
  },
  /**
   * 刷脸支付
   */
  smilePay<T = any>(
    amount: number,
    success: (result: T) => void,
    fail: (result: T) => void
  ): void {
    throwErrorMsg("pay.smilePay")
  },
  /**
   * 接入方自己实现扫码，传入payCode
   */
  payCode(amount: number, payCode: string): void {
    throwErrorMsg("pay.payCode")
  },
} as PayDSL

/**
 * 支付宝刷脸支付
 */
export const alipay = {
  /**
   * 使用支付宝刷脸SDK，获取运行该应用的设备信息
   * @param param
   */
  deviceInfo({ merchantId, partnerId, appId, deviceNum }) {
    throwErrorMsg("alipay.deviceInfo")
  },

  verify({ zimId, protocol, mode, number }) {
    throwErrorMsg("alipay.verify")
  },

  exit() {
    throwErrorMsg("alipay.exit")
  },
} as AliPay
